import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import StagiaireList  from '../../components/DashBoard/CatalogList/StagiaireList'
import Meta from '../../components/Helmet/Meta'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import './dashboard.css'

const StagiaireListScreendas = () => {
    return (
        <div   className="main"  fluid >
            <Meta title=" | Admin Users" />
            <Container fluid className="main">
                <Row>
                    <Col md={3}>
                    </Col>
                    <Col md={9}>
                        <h4 > Liste des stagiaires </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <StagiaireList />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default StagiaireListScreendas
